<div class="container" *ngIf="quest">
  <div class="row mt-5 text-center">
    <div class="col-sm-12">
      <h2 class="display-4">{{ quest.name }}</h2>
      <h4>{{ quest.description }}</h4>
    </div>
  </div>
</div>
